<template>
    <!--VIP升级-->
    <ZhaiHead></ZhaiHead>

    <!--九宫格-->
    <div class="container-fluid zhu mb-2">
        <ZhaiJiuGong menu="5"></ZhaiJiuGong>
    </div>

    <!--主体-->
    <div class="container-fluid py-2">
        <div class="row shengse">
            <div class="dixian px-3 py-2 d-flex justify-content-between">
                <div>升级VIP</div>
            </div>

            <div class="p-3">
                <div class="jiacu mb-2">
                    会员类型和价格
                </div>

                <div class="huiziti pt-2 mb-2">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th scope="col">类型</th>
                            <th scope="col">价格</th>
                            <th scope="col">查看内容</th>
                            <th scope="col">有效期</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in membershipOptions" :key="index">
                            <td>{{ item.type }}</td>
                            <td>{{ item.price }}元</td>
                            <td>{{ item.content }}</td>
                            <td>{{ item.duration }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 公共补差价红条 -->
                <VipUpgradeDiffBanner
                        ref="vipDiffBanner"
                        :user-id="getUser && getUser.id"
                        @select="handleSelectPermanentUpgrade"
                />

                <!--按钮-->
                <div class="G-Btns my-2">
                    <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[0])">
                        <span class="btn-text">月度会员</span><span class="btn-price">188元</span>
                    </button>
                    <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[1])">
                        <span class="btn-text">年度会员</span><span class="btn-price">288元</span>
                    </button>
                    <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[2])">
                        <span class="btn-text">永久会员</span><span class="btn-price">499元</span>
                    </button>
                </div>

                <!--提醒-->
                <div class="text-primary mt-3 buyinfo">
                    会员升级是通过第三方代收款，商品名称可能不一致，请核对支付金额后放心支付。
                </div>
                <div class="text-primary mt-3 buyinfo" style="background: #000000;color: #f9ff00!important;">
                    支付成功后如果VIP没有生效，请<strong>退出重新登录</strong>，正常情况下支付成功后，30秒内即可完成升级！
                    如果重新登录后依然是普通会员，请联系客服邮箱：<strong>yufenglou321@gmail.com</strong>，提供你的<strong>用户名和支付订单详情页截图</strong>，我们将在24小时内为你处理。
                </div>
            </div>

            <!--升级帮助-->
            <div class="row shengse">
                <div class="dixian px-3 py-2 d-flex justify-content-between">
                    <div>升级帮助</div>
                </div>
                <div class="p-3 uphelp" style="font-size:1rem">
                    <h1 class="jiacu text-dark">
                        充值成功了，为什么还是普通会员?
                    </h1>
                    <p>
                        1、若付款后，仍是普通会员，请<strong>退出并重新登录</strong>即可刷新会员状态。
                    </p>
                    <br>
                    <h1 class="jiacu text-dark">
                        系统显示正在生成订单，无法显示支付？
                    </h1>
                    <p>
                        由于系统支付订单较多，可能出现无法生成支付订单的情况，请多试几遍不同的支付方式，或过一会再一下。通常这只是暂时性的。
                    </p>
                    <br>
                    <h1 class="jiacu text-dark">
                        遇到问题，怎样联系客服?
                    </h1>
                    <p>
                        发送你的用户名和支付订单的详情页截图（详情页！！！）至邮箱，我们将在24小时内为你处理。客服邮箱：yufenglou321@gmail.com
                    </p>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>

    <!--升级支付 模态框 -->
    <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="line-height:30px;">
                    <div id="step1">
                        <div>
                            升级VIP目前仅支持支付宝，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
                        </div>
                        <div class="mt-2">
                            <strong>升级类型：</strong>
                            <span id="uplevel">{{ modalData.type }}</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付金额：</strong>
                            <span id="payamount">{{ modalData.amount }}元</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付方式：</strong>
                            <label class="pay-option1">
                                <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                                {{ alipayOptionText }}
                            </label>
                        </div>
                        <div class="mt-2" style="color:red;">
                            如果支付加载不出来，多试几次就成功了。
                        </div>
                        <div class="text-center mt-5">
                            <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
                            <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
                        </div>
                    </div>

                    <div id="step2" style="display:none;">
                        <div id="paymsg" style="color: #00c26f;text-align: center;font-size: 1rem;font-weight: bold;"></div>
                        <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
                            如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
                        </p>
                        <p style="text-align: center;font-size: 1rem;color: #000;">
                            请确认支付完成后，再点击“支付完成”
                        </p>
                        <div class="text-center">
                            <button id="btnpaysucess" class="btn btn-primary mr-5" @click="onManualCheckPayment">支付完成</button>
                            <button class="btn btn-primary mr-5" data-bs-dismiss="modal">关闭</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 1.5rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" id="successMessage" style="font-size: 0.9rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
            <div class="modal-content shake">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 1.5rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" id="errorMessage" style="font-size: 0.9rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 时间限制提示模态框 -->
    <div class="modal fade" id="timeRestrictionModal" tabindex="-1" aria-labelledby="timeRestrictionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 350px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-clock" style="font-size: 2rem; color: red;"></i>
                    <p class="mb-0 ms-2" id="timeRestrictionMessage" style="font-size: 1rem; color: red;"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import ZhaiJiuGong from "../components/ZhaiJiuGong";
    import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
    import { Modal } from "bootstrap";
    import QRCode from "qrcodejs2";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "MUpgradeVIP",
        components: { ZhaiHead, ZhaiFoot, ZhaiJiuGong, VipUpgradeDiffBanner },

        data() {
            return {
                modalData: { type: "", amount: 0 },
                payType: "2040",
                membershipOptions: [
                    { type: "VIP月度会员", price: 188, content: "楼凤", duration: "+1月" },
                    { type: "VIP年度会员", price: 288, content: "楼凤+暗巷", duration: "+1年" },
                    { type: "VIP永久会员", price: 499, content: "所有", duration: "永久" }
                ],
                orderId: null,
                manualPolling: false
            };
        },

        computed: {
            ...mapGetters(["getUser", "isLoggedIn"]),
            alipayOptionText() {
                return "支付宝";
            }
        },

        methods: {
            handleSelectPermanentUpgrade(payload) {
                this.modalData.type = payload.type;
                this.modalData.amount = payload.amount;
                this.openModal();
            },

            showTimeRestrictionModal(message) {
                document.getElementById("timeRestrictionMessage").innerText = message;
                const timeModal = new Modal(document.getElementById("timeRestrictionModal"));
                timeModal.show();

                setTimeout(() => {
                    timeModal.hide();
                }, 5000);
            },

            selectMembership(item) {
                this.modalData.type = item.type;
                this.modalData.amount = item.price;
                this.openModal();
            },

            openModal() {
                document.getElementById("step1").style.display = "block";
                document.getElementById("step2").style.display = "none";

                const paymsg = document.getElementById("paymsg");
                if (paymsg) {
                    paymsg.innerHTML = "";
                }

                const modalElement = document.getElementById("upgradeModal");
                const modalInstance = new Modal(modalElement);
                modalInstance.show();
            },

            resetPayButton() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "支付";
                    payButton.disabled = false;
                }
            },

            startPayment() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "生成中";
                    payButton.disabled = true;
                }

                const { id: userid, username, email } = this.getUser || {};
                if (!userid || !username || !email) {
                    this.resetPayButton();
                    alert("用户信息不完整，请重新登录！");
                    return;
                }

                let requestUrl = "";

                if (this.modalData.type === "限时补差价升级永久会员") {
                    requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                } else {
                    requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                }

                http.get(requestUrl)
                    .then(response => {
                        const res = response.data;
                        console.log("支付接口返回:", res);

                        if (res && res.status === 1 && res.data) {
                            const { payUrl, mchOrderNo } = res.data;

                            if (!payUrl) {
                                this.resetPayButton();
                                this.showFailureModal("支付链接为空，请联系管理员！");
                                return;
                            }

                            this.orderId = mchOrderNo;
                            this.generateQRCode(payUrl);
                        } else {
                            this.resetPayButton();
                            const errorMessage = res?.msg || "未知错误";
                            this.showFailureModal(`支付请求失败：${errorMessage}`);
                        }
                    })
                    .catch(error => {
                        this.resetPayButton();
                        this.showFailureModal(`请求支付失败，请重试。错误详情: ${error.message}`);
                    });
            },

            generateQRCode(payUrl) {
                document.getElementById("paymsg").innerHTML = "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。";

                const qrCodeContainer = document.createElement("div");
                qrCodeContainer.id = "qrcode";
                qrCodeContainer.style.width = "200px";
                qrCodeContainer.style.height = "200px";
                qrCodeContainer.style.marginTop = "20px";

                document.getElementById("paymsg").appendChild(qrCodeContainer);

                new QRCode(qrCodeContainer, {
                    text: payUrl,
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });

                document.getElementById("step1").style.display = "none";
                document.getElementById("step2").style.display = "block";

                let remainingTime = 300;

                const countdown = document.createElement("p");
                countdown.id = "countdown";
                countdown.style.textAlign = "center";
                countdown.style.marginTop = "10px";
                countdown.style.fontWeight = "normal";
                countdown.style.color = "rgba(255, 127, 127)";
                countdown.style.fontSize = "0.9rem";
                document.getElementById("paymsg").appendChild(countdown);

                const timer = setInterval(() => {
                    if (remainingTime <= 0) {
                        clearInterval(timer);
                        countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
                        qrCodeContainer.style.filter = "blur(5px)";
                        this.resetPayButton();
                    } else {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;
                        countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
                        remainingTime--;
                    }
                }, 1000);
            },

            onManualCheckPayment() {
                this.manualPolling = true;
                this.checkPaymentStatus();
            },

            checkPaymentStatus() {
                if (!this.orderId) return;

                const statusUrl = `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${this.orderId}`;

                fetch(statusUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 1) {
                            this.handlePaymentSuccessStatus();
                        } else if (this.manualPolling) {
                            this.showFailureModal("未检测到支付完成，请稍后重试");
                        }
                    })
                    .catch(error => {
                        console.error("轮询支付状态异常:", error);
                    });
            },

            handlePaymentSuccessStatus() {
                this.$store.dispatch("checkLoginStatus");

                if (this.$refs.vipDiffBanner) {
                    this.$refs.vipDiffBanner.refresh();
                }

                this.showSuccessModal("支付已成功");
            },

            showSuccessModal(message) {
                document.getElementById("successMessage").innerText = message;
                const successModal = new Modal(document.getElementById("successModal"));
                successModal.show();

                setTimeout(() => {
                    successModal.hide();
                    document.body.classList.remove("modal-open");
                    const backdrop = document.querySelector(".modal-backdrop");
                    if (backdrop) {
                        backdrop.remove();
                    }
                    this.$router.push("/memberCenter");
                }, 3000);
            },

            showFailureModal(message) {
                document.getElementById("errorMessage").innerText = message;
                const errorModal = new Modal(document.getElementById("errorModal"));
                errorModal.show();

                setTimeout(() => {
                    errorModal.hide();
                }, 3000);
            }
        },

        watch: {
            isLoggedIn(val) {
                if (!val) {
                    this.$router.push("/login");
                }
            }
        },

        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) {
                next("/login");
            } else {
                next();
            }
        },

        mounted() {
            setTimeout(() => {
                const loadingModal = document.getElementById("loading");
                if (loadingModal) {
                    const modal = new Modal(loadingModal, { keyboard: false });
                    modal.hide();
                }
            }, 8000);
        }
    };
</script>

<style scoped>
    /*VIP明细表格表头背景颜色*/
    .table th {
        background-color: #d5d5d5;
        text-align: center;
    }

    /*VIP明细表格内容居中*/
    .table td {
        text-align: center;
    }

    /* 四个按钮容器 */
    .G-Btns {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        gap: 8px;
        flex-wrap: nowrap;
    }

    /* 四个绿色按钮 */
    .membership-btn {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 60px;
        text-align: center;
        font-size: 1rem;
        line-height: 1.2;
        padding: 0;
        border-radius: 10px;
    }

    /* 按钮文字 */
    .btn-text {
        margin-bottom: 2px;
        white-space: nowrap;
    }

    .btn-price {
        color: #ffffff;
        white-space: nowrap;
    }

    /* 按钮颜色 */
    .btn-success {
        background-color: #00c26f !important;
        border: none !important;
    }

    /* 支付按钮 */
    #btnpaysucess,
    .modal-body .btn-primary {
        background-color: #00c26f !important;
        border: none !important;
    }

    /* 默认按钮不再有右间距 */
    .btn {
        margin-right: 0;
    }

    /* 付款提醒 */
    .buyinfo {
        font-size: 1rem;
        background: #f1f1f1;
        padding: 20px;
        color: red !important;
    }

    /* 升级帮助文字 */
    .uphelp h1,
    .uphelp p {
        font-size: 1rem;
    }

    /* 模态框标题 */
    .modal-title {
        font-size: 1rem;
    }

    /* 模态框按钮间距 */
    .modal-body .btn {
        margin-right: 60px;
    }

    .modal-body .btn:last-child {
        margin-right: 0;
    }

    /* 模态框位置 */
    .modal-dialog {
        margin-top: 25%;
    }

    /* 顶部间距 */
    .zhu {
        margin-top: 80px;
    }

    /* 支付二维码区域 */
    #paymsg {
        color: #00c26f;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* 二维码 */
    #qrcode {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: filter 0.5s ease;
    }

    /* 支付倒计时 */
    #countdown {
        font-size: 0.7rem;
        color: red !important;
        text-align: center;
        margin-bottom: 0 !important;
    }

    /* 失败模态框 */
    .modal-dialog.modal-shake {
        margin: auto;
        max-width: 200px;
    }

    /* 时间限制提示模态框 */
    #timeRestrictionModal .modal-dialog {
        margin: 2% auto !important;
        max-width: 350px;
    }

    /* 支付方式间距 */
    .pay-option1 {
        margin-right: 35px;
    }

    /* 小屏适配 */
    @media (max-width: 420px) {

        .membership-btn {
            height: 56px;
            font-size: 0.9rem;
        }

        .btn-text,
        .btn-price {
            font-size: 0.9rem;
        }

        .G-Btns {
            gap: 6px;
        }

    }

</style>
